import React, { useState, useRef } from 'react';
import { TERMS_PDF_URL } from './Config';
import './ibcartao.css';
import './ViewPDF.css';
import { sendEvent, LEAD_API_URL } from './Config';


function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

function buildChromeIntentUrl(url) {
    try {
        const u = new URL(url);
        const scheme = u.protocol.replace(':', '');
        const fallback = encodeURIComponent(url);
        return `intent://${u.host}${u.pathname}${u.search}${u.hash}#Intent;scheme=${scheme};action=android.intent.action.VIEW;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
    } catch (e) {
        return url;
    }
}

const ViewPDF = function () {
    const [hasRequestedPdf, setHasRequestedPdf] = useState(false);
    const [hasAgreed, setHasAgreed] = useState(false);
    const [hasAccepted, setHasAccepted] = useState(false);
    const hasDocument = Boolean(TERMS_PDF_URL.trim());
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

const pdfUrl = `${LEAD_API_URL}/signup/init?leadId=${encodeURIComponent(leadIdRef.current)}&lang=pt`;
    const pdfHref = isAndroid() ? buildChromeIntentUrl(pdfUrl) : pdfUrl;

    const handleAccept = (event) => {
        event.preventDefault();

        if (!hasDocument || !hasRequestedPdf || !hasAgreed || hasAccepted) return;

        // Local UI confirmation only. Persist acceptance through the backend
        // before connecting this action to the next onboarding step.
        setHasAccepted(true);
    };

    return <>
        <header className="header flex items-center">
            <div className="content flex items-center gap-x-4">
                <div className="flex items-center w-auto border-r pr-4">
                    <img src="/assets/img/bb-logo.svg" className="logo" alt="Banco do Brasil" />
                </div>
                <div className="flex-1">
                    <span className="subtitle">O cartão mais sofisticado do mercado</span>
                </div>
            </div>
        </header>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 '></div>
            <div className='flex-1 '></div>
            <div className='flex-1 '></div>
        </div>

        <main className="container">
            <div className="content terms-content mt-8">
                <h1>Conheça os termos de utilização do seu cartão.</h1>
                <p className='mt-6 separator-bottom pb-5'>Conheça as condições de utilização do seu cartão.
                    Abra o documento e leia com atenção antes de confirmar seu aceite.</p>
                <div className="pt-4"></div>

                <section className="terms-page__document" aria-labelledby="terms-document-title">
                    <h2 id="terms-document-title" >Termos de utilização do cartão BB Altus</h2>
                    <p id="terms-open-help">
                        O PDF será aberto em outra aba ou no visualizador do seu celular.
                        Depois da leitura, volte a esta página para aceitar os termos.
                    </p>
                    {hasDocument ? (
                        <a
                            href={pdfHref}
                            rel="noopener noreferrer"
                            className="primary terms-page__action mt-4"
                            aria-describedby="terms-open-help"
                            onClick={() => setHasRequestedPdf(true)}
                        >
                            {false ? 'Abrir PDF novamente' : 'Abrir e ler os termos (PDF)'}
                        </a>
                    ) : (
                        <p className="terms-page__notice" role="status">
                            O documento está indisponível no momento.
                            Por favor, tente novamente mais tarde.
                        </p>
                    )}
                </section>

                <form onSubmit={handleAccept} className="terms-page__form">
                    <p id="terms-accept-help" className="terms-page__help" aria-live="polite">
                        {!hasDocument
                            ? 'O aceite ficará disponível quando você puder acessar os termos.'
                            : !hasRequestedPdf
                                ? 'Primeiro, abra o PDF para ler os termos.'
                                : 'Se conseguiu ler o documento e está de acordo, marque a confirmação abaixo.'}
                    </p>
                    <label className="terms-page__consent" htmlFor="terms-consent">
                        <input
                            id="terms-consent"
                            type="checkbox"
                            required
                            checked={false}
                            disabled={true}
                            aria-describedby="terms-accept-help"
                            onChange={(event) => setHasAgreed(event.target.checked)}
                        />
                        <span>Li e concordo com os termos de utilização do cartão BB Altus.</span>
                    </label>
                    <button
                        type="submit"
                        className="primary terms-page__action"
                        disabled={!hasDocument || !hasRequestedPdf || !hasAgreed || hasAccepted}
                    >
                        {hasAccepted ? 'Termos aceitos' : 'Aceitar termos'}
                    </button>
                    <div role="status" aria-live="polite">
                        {hasAccepted && (
                            <p className="terms-page__confirmation">
                                Você confirmou a leitura e o aceite dos termos.
                            </p>
                        )}
                    </div>
                </form>
            </div>
        </main>
    </>;
};

export default ViewPDF;
